<template>
  <v-data-table :headers="headers" :items="filteredFacilitators" sort-by="text">
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          label="Busca"
          v-model="filter"
          outlined
          dense
          hide-details
          clearable
          append-icon="eva-search-outline"
        />

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Novo facilitador
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      denses
                      v-model="editedItem.text"
                      v-uppercase
                      label="Texto"
                      :hide-details="!errors.editedItem"
                      :error-messages="errors.editedItem"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_facilitator_bio"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_bio"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há facilitadores Biomicroscopia cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
import { normalizeString } from "@/helpers/string_helpers.js";

export default {
  name: "ConfigBioList",
  props: {
    facilitators: Array,
    facilitatorType: String,
    refreshList: Function,
  },
  data() {
    return {
      errors: {},
      dialog: null,
      editedItem: {},
      editedIndex: -1,
      filter: "",
      headers: [
        { text: "Texto", value: "text" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    filteredFacilitators() {
      let facilitators = this.lodash.filter(this.facilitators, {
        facilitatorType: this.facilitatorType,
      });

      if (this.filter) {
        facilitators = this.lodash.filter(
          facilitators,
          function (e) {
            return normalizeString(e.text)
              .includes(
                normalizeString(this.filter)
              );
          }.bind(this)
        );
      }

      return facilitators;
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Novo facilitador"
        : "Editar facilitador";
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.filteredFacilitators.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Você realmente deseja deletar esse facilitador?")) {
        this.apolloMutate({
          mutation: require("@/graphql/biomicroscopy/delete_biomicroscopy_facilitator.gql"),
          variables: {
            biomicroscopyFacilitatorId: item.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Facilitador deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: require("@/graphql/biomicroscopy/save_biomicroscopy_facilitator.gql"),
        variables: {
          biomicroscopyFacilitatorId: this.lodash.get(
            this.editedItem,
            "id",
            ""
          ),
          text: this.editedItem.text,
          facilitatorType: this.facilitatorType,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      let text = this.editedItem.text;
      if (this.lodash.isEmpty(text?.trim())) {
        this.errors.editedItem = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
